<template>
  <div class="selfCenter">
    <div class="baceInfoTop">
      <div class="userInfo">
        <div class="photoBox">
          <img
            :src="
              userInfo.pic
                ? userInfo.pic
                : require('../../assets/img/personal/icon_default_portrait@2x.png')
            "
            alt=""
          />
        </div>
        <div class="userBase">
          <p class="userName">
            {{ userInfo.nickname ? userInfo.nickname : "用户"
            }}<i v-if="userInfo.group_name" class="vip">
              <img
                src="../../assets/img/personal/btn_register_member@2x.png"
                alt=""
                style="width: 0.11rem; height: 0.1rem; margin-right: 0.035rem"
              />{{ userInfo.group_name }}
            </i>
          </p>
          <p class="proxyArea" v-show="userInfo.region">
            代理区域：{{ userInfo.region ? userInfo.region : "暂无" }}
          </p>
        </div>
      </div>
      <div class="shareUrl">
        邀请链接：<span class="url" @click="copyUrl">{{
          userInfo.shareUrl
        }}</span>
      </div>
      <input
        ref="urlContent"
        v-model="userInfo.shareUrl"
        style="position: absolute; top: 0; left: 0; opacity: 0; z-index: -10"
        type="text"
      />
    </div>
    <div class="walletBox">
      <van-cell
        style="height: 0.49rem"
        :border="false"
        center
        title="我的钱包"
        :icon="require('../../assets/img/personal/personal_icon_wallet@2x.png')"
      />
      <div class="walletContain">
        <van-tabbar
          :border="false"
          :fixed="false"
          active-color="#333333"
          inactive-color="#333333"
        >
          <van-tabbar-item :to="{ name: '积分详情' }">
            <span>积分余额</span>
            <template #icon="props">
              <p>{{ userInfo.money ? parseInt(userInfo.money) : 0 }}</p>
            </template>
          </van-tabbar-item>
          <van-tabbar-item @click="$router.push({ name: '数据统计' })">
            <span>积分总收益</span>
            <template #icon="props">
              <p>{{ userInfo.money_total ? userInfo.money_total : 0 }}</p>
            </template>
          </van-tabbar-item>
          <van-tabbar-item :to="{ name: '积分商城' }">
            <span>购物积分</span>
            <template #icon="props">
              <p>{{ userInfo.points ? userInfo.points : 0 }}</p>
            </template>
          </van-tabbar-item>
          <van-tabbar-item @click="$router.push({ name: '邀请海报' })">
            <span>分享推广</span>
            <template #icon="props">
              <p>{{ userInfo.agentnum ? userInfo.agentnum : 0 }}</p>
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
    <div class="orderManage">
      <van-cell
        style="height: 0.49rem"
        :border="false"
        center
        title="订单管理"
        :icon="require('../../assets/img/personal/personal_icon_order@2x.png')"
      />
      <div class="orderContain">
        <van-tabbar
          :border="false"
          :fixed="false"
          active-color="#333333"
          inactive-color="#333333"
        >
          <van-tabbar-item
            @click="
              $router.push({ name: '订单', params: { activeNum: ['', 1] } })
            "
          >
            <span>全部订单</span>
            <template #icon="props">
              <img src="../../assets/img/personal/order_btn_whole@2x.png" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item
            @click="
              $router.push({ name: '订单', params: { activeNum: [0, 2] } })
            "
          >
            <span>待付款</span>
            <template #icon="props">
              <img src="../../assets/img/personal/order_btn_payment@2x.png" />
              <div class="payments_num">
                <span>{{
                  userInfo.paynum
                    ? Number(userInfo.paynum) >= 100
                      ? "99+"
                      : userInfo.paynum
                    : "0"
                }}</span>
              </div>
            </template>
          </van-tabbar-item>
          <van-tabbar-item
            @click="
              $router.push({ name: '订单', params: { activeNum: [1, 3] } })
            "
          >
            <span>待发货</span>
            <template #icon="props">
              <img src="../../assets/img/personal/order_btn_horder@2x.png" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item
            @click="
              $router.push({ name: '订单', params: { activeNum: [2, 4] } })
            "
          >
            <span>已完成</span>
            <template #icon="props">
              <img src="../../assets/img/personal/order_btn_complete@2x.png" />
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
    <div class="listCellOne">
      <van-cell
        style="height: 0.49rem"
        center
        title="我的库存"
        :icon="require('../../assets/img/personal/personal_icon_stock@2x.png')"
        is-link
        :to="{ name: '我的库存' }"
        v-show="userInfo.agent != 0"
      />
      <van-cell
        style="height: 0.49rem"
        center
        title="积分奖励"
        :icon="require('../../assets/img/personal/personal_icon_reward@2x.png')"
        is-link
        :to="{ name: '积分奖励' }"
      />
      <van-cell
        style="height: 0.49rem"
        center
        title="积分详情"
        :icon="
          require('../../assets/img/personal/personal_icon_details_integral@2x.png')
        "
        is-link
        :to="{ name: '积分详情' }"
      />
      <van-cell
        style="height: 0.49rem"
        center
        title="我的好友"
        :icon="require('../../assets/img/personal/personal_icon_friend@2x.png')"
        is-link
        :to="{ name: '我的好友' }"
      />
      <van-cell
        style="height: 0.49rem"
        center
        title="我的收藏"
        :icon="
          require('../../assets/img/personal/personal_icon_collection@2x.png')
        "
        is-link
        :to="{ name: '我的收藏' }"
      />
    </div>
    <div class="listCellTwo">
      <van-cell
        style="height: 0.49rem"
        center
        title="地址管理"
        :icon="require('../../assets/img/personal/personal_icon_adress@2x.png')"
        is-link
        :to="{ name: '收货地址' }"
      />
      <van-cell
        style="height: 0.49rem"
        center
        title="个人资料"
        :icon="require('../../assets/img/personal/personal_icon_data@2x.png')"
        is-link
        :to="{
          name: '个人资料',
          params: {
            info: {
              pic: userInfo.pic,
              name: userInfo.nickname,
              phone: userInfo.username,
            },
          },
        }"
      />
    </div>
    <div class="loginOut">
      <van-button @click="loginOut()" round :block="true">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/home.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      userInfo: {},
      share: {},
    };
  },
  activated() {
    getUserInfo()
      .then((res) => {
        this.userInfo = res.data.backdata.userinfo;
        this.share = res.data.backdata.share;
        // 微信分享
        const config = {
          appId: "wx90d063c3fc548e01",
          shareTitle: this.share.share_title,
          shareTxt: this.share.share_desc,
          shareUrl: this.share.share_url,
          imgUrl: this.share.share_pic,
        };
        wxint(config);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // created() {
  //   getUserInfo()
  //     .then((res) => {
  //       this.userInfo = res.data.backdata.userinfo;
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // },
  methods: {
    // 复制链接
    copyUrl() {
      this.$refs.urlContent.select();
      document.execCommand("Copy");
      Toast("复制成功");
    },
    onClickLeft() {
      if (this.$route.params.rePath) {
        this.$router.push(this.$route.params.rePath);
      } else {
        this.$router.back();
      }
    },
    loginOut() {
      this.$dialog
        .confirm({
          message: "确定退出？",
        })
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push({ name: "登录", params: { rePath: "/home" } });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang='scss'>
.selfCenter {
  height: 100%;
  background: rgb(243, 241, 244);

  .van-cell__left-icon {
    margin-right: 0.08rem;
  }
  .van-icon__image {
    margin-top: 0.02rem;
    width: 0.18rem;
    height: 0.18rem;
  }
  // 右侧箭头
  .van-cell--clickable {
    .van-icon-arrow::before {
      content: "\F00A";
      font-size: 0.12rem;
      color: #333333;
    }
  }
  .baceInfoTop {
    width: 100%;
    height: 1.81rem;
    position: relative;
    background: url("../../assets/img/personal/bg_banner@2x.png") no-repeat;
    background-size: contain;
    .shareUrl {
      width: 3.45rem;
      height: 0.46rem;
      line-height: 0.46rem;
      text-align: center;
      background: #ffffff;
      box-shadow: 0px 3px 5px 0px rgba(0, 83, 16, 0.04);
      border-radius: 8px;
      position: absolute;
      bottom: -0.22rem;
      left: 0.15rem;
      color: #333333;
      font-size: 0.12rem;
      .url {
        color: #93683d;
        padding: 0.08rem 0;
      }
    }
    .userInfo {
      width: 100%;
      display: flex;
      padding: 0 0.15rem;
      padding-top: 0.68rem;
      .userBase {
        padding: 0.05rem 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        color: #93683d;
        .userName {
          font-size: 0.16rem;
          font-weight: 900;
          display: flex;
          .vip {
            display: inline-block;
            display: flex;
            align-items: center;
            padding: 0 0.095rem;
            height: 0.21rem;
            margin-left: 0.08rem;
            background: linear-gradient(90deg, #fffbdd 0%, #e7e0aa 100%);
            border-radius: 0.1rem;

            font-size: 0.12rem;
            font-weight: bold;
            color: #664101;
          }
        }
        .proxyArea {
          font-size: 0.12rem;
        }
      }
      .photoBox {
        width: 0.54rem;
        height: 0.54rem;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 0.1rem;
        img {
          width: 0.54rem;
          height: 0.54rem;
        }
      }
    }
    .van-nav-bar--fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 0.64rem;
      background: none;
    }
    .van-icon-arrow-left {
      width: 0.1rem;
      height: 0.17rem;
      background-image: url("../../assets/img/nav_return@2x.png");
      background-repeat: no-repeat;
      background-size: 0.1rem 0.17rem;
    }
    .van-icon-arrow-left::before {
      content: "";
    }
  }
  .van-cell__title {
    font-size: 0.14rem;
  }
  // 我的钱包
  .walletBox {
    width: 100%;
    height: 1.47rem;
    margin-bottom: 0.11rem;
    padding: 0.26rem 0 0.22rem;
    background-color: #ffffff;

    .van-tabbar-item {
      font-size: 0.12rem;
    }
    .van-tabbar-item__icon {
      margin-bottom: 0.12rem;
      p {
        font-size: 0.16rem;
        font-weight: 900;
      }
    }
  }
  // 订单管理
  .orderManage {
    width: 100%;
    height: 1.31rem;
    background-color: #ffffff;
    margin-bottom: 0.11rem;
    .van-cell--center {
      padding-top: 0.14rem;
    }
    .orderContain {
      margin-top: 0.1rem;
    }
    .van-icon__image {
      margin-top: 0.03rem;
      width: 0.16rem;
      height: 0.16rem;
    }
    .van-tabbar-item {
      font-size: 0.12rem;
      position: relative;
      .payments_num {
        min-width: 0.21rem;
        height: 0.12rem;
        background: #f23443;
        border-radius: 0.02rem;

        text-align: center;
        position: absolute;
        top: -0.05rem;
        left: 0.15rem;
        span {
          display: block;
          height: 0.12rem;
          line-height: 0.12rem;
          transform: scale(0.75);
          font-size: 0.12rem;
          color: #ffffff;
        }
      }
    }
    .van-tabbar-item__icon {
      margin-bottom: 0.12rem;
      img {
        width: 0.25rem;
        height: 0.25rem;
      }
    }
  }

  .listCellOne {
    margin-bottom: 0.11rem;
  }
  .loginOut {
    width: 100%;
    height: 0.82rem;
    margin-bottom: 0.49rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-button {
      width: 2.72rem;
      height: 0.44rem;
      color: #93683d;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);

      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
  }
}
</style>
